import Button from "@mui/material/Button";
import { useIsMobile } from "../hooks/useIsMobile";

const PinSelectConfirmation = ({
  confirm,
  cancel,
}: {
  confirm: () => void;
  cancel: () => void;
}) => {
  const isMobile = useIsMobile(768);

  return (
    <>
      <div
        id="focusOnSelectingPinLocation-hideAppBar"
        className="appBar "
        style={{
          position: "fixed", // Opaque background
          top: 0,
          left: 0,
          right: 0,
          zIndex: 22,
          backgroundColor: "rgba(15, 44, 82, 0.5)", // Selecting pin location
        }}
      />
      <div
        id="focusOnSelectingPinLocation-hideSearchPanel"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: 400,
          backgroundColor: "rgba(15, 44, 82,.5)",
          zIndex: 1,
        }}
      />
      <div
        id="pinSelectConfirmation"
        style={{
          position: isMobile ? "fixed" : "absolute",
          bottom: isMobile ? 80 : 20,
          left: 20,
          width: 200,
          padding: 15,
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          borderRadius: 10,
          border: "3px solid #148dd3",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 6,
            height: 80,
            padding: "0px 5px",
            color: "#09B0F2",
            paddingBottom: 10,
          }}
        >
          <div>1. Scroll to zoom in / out </div>
          <div>2. Click to drop a pin on your desired location</div>
        </div>

        <div style={{ display: "flex", gap: 20 }}>
          <Button
            id="pinSelectConfirmButton"
            fullWidth
            variant="contained"
            onClick={confirm}
          >
            Confirm
          </Button>
          <Button
            id="pinSelectCancelButton"
            fullWidth
            variant="outlined"
            color="neutral"
            onClick={cancel}
          >
            Cancel
          </Button>
        </div>
      </div>
    </>
  );
};

export default PinSelectConfirmation;
